import React from 'react';
import {AUTH_TOKEN_STORAGE_KEY} from '../constants/storageConstants';
import {logoutMutation} from '../qql-shared/mutations';
import {withNamespaces} from 'react-i18next';
import {graphql} from 'react-apollo';
import {LogoutItem} from './SidebarContent';

const Logout = ({mutate, t}) => {
  return (
    <LogoutItem
      onClick={() => {
        mutate().then((response) => {
          localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
          window.location.reload();
        });
      }}>
      {t('sidebar.logout')}
    </LogoutItem>
  );
};

export default withNamespaces()(graphql(logoutMutation)(Logout));



// WEBPACK FOOTER //
// ./src/components/Logout.js